import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import {loadLanguageAsync} from './global-languages';
import {globalEventBus, globalEventNames} from './global-dispatcher';

//import {version} from "../package.json";
import packageInfo from '../package.json';

Vue.use(Vuex);

export const globalStoreMethods = {

    state: {
        clientAppToken: 'clientAppToken',
        ready: 'ready',
        busy: 'busy',

        allCultures: 'allCultures',
        currentCulture: 'currentCulture',
        loggedUser: 'loggedUser',
        version: 'version',
        userType: 'userType',
        toolbars: 'toolbars'
    },

    getters: {
        isAdmin: 'isAdmin',
        isStandard: 'isStandard',
        layout: 'layout',

    },

    mutations: {

        setLayout: 'setLayout',
        setBusy: 'setBusy',
        setLoggedUser: 'setLoggedUser',
    },

    actions: {

        changeCulture: 'changeCulture',
        init: 'init',
        setUserAndCulture: 'setUserAndCulture'
    }

};

// creazione dello store (modulo root - base)
const globalStore = new Vuex.Store({

    state: {

        clientAppToken: '',                     // token applicazione primaria
        ready: false,                           // store disponibile (informazioni remote e localStorage)
        busy: false,                            // qualche chiamata ajax attiva
        loggedUser: null,
        layout: 'layout-login',                 // layout utilizzato dalla pagina gestita tramite il router
        allCultures: [],                        // elenco delle allCultures disponibili per il sito
        timeZones: [],                           // elenco fusi orari
        currentCulture: null,                   // cultura corrente
        version: packageInfo.version,           // versione applicativo
        userType: {
            standard: 'STANDARD',
            supervisor: 'SUPERVISOR',
            administrator: 'ADMINISTRATOR',
            operative: 'OPERATIVE',
            translator: 'TRANSLATOR',
        },
        toolbars: {
            bold: true,
            italic: true,
            header: true,
            underline: true,
            strikethrough: true,
            mark: true,
            superscript: true,
            subscript: true,
            quote: true,
            ol: true,
            ul: true,
            link: true,
            imagelink: false,
            code: false,
            table: true,
            fullscreen: true,
            readmodel: true,
            htmlcode: true,
            help: true,
            /* 1.3.5 */
            undo: true,
            redo: true,
            trash: false,
            save: false,
            /* 1.4.2 */
            navigation: false,
            /* 2.1.8 */
            alignleft: true,
            aligncenter: true,
            alignright: true,
            /* 2.2.1 */
            subfield: true,
            preview: true,
        }
    },

    getters: {

        // layout utilizzato dalla pagina gestita tramite il router
        layout(state) {
            return state.layout;
        },

        // verifica se è disponibile in operatore autenticato
        isAuthenticated: (state) => state.loggedUser !== null && state.loggedUser.token !== null,

        isAdmin: (state) => state.loggedUser !== null && state.loggedUser.operatorType === state.userType.administrator,
        isStandard: (state) => state.loggedUser !== null && state.loggedUser.operatorType === state.userType.standard,

        // loggedUser:() => JSON.parse(localStorage.getItem('01/loggedUser'))

        getTimeZoneDescriptionById: (state) => (id) => {
            return state.timeZones.find(a => a.id === id)?.description;
        }

    },

    mutations: {

        // registrazione appToken valido per tutte l'applicazione corrente
        _setClientAppToken: (state, clientAppToken) => state.clientAppToken = clientAppToken,

        // notifica inizializzazione avvenuta
        _setReady(state, {allCultures, timeZones}) {
            state.allCultures = allCultures;
            state.timeZones = timeZones;
            state.ready = true;
        },

        // cambio lingua corrente
        _setCurrentCulture(state, currentCulture) {
            if (!currentCulture) {
                currentCulture = state.allCultures.filter(x => x.id === 1)[0];
            }
            state.currentCulture = currentCulture;

            axios.defaults.headers.common['Accept-Language'] = currentCulture.code;
            document.querySelector('html').setAttribute('lang', currentCulture.code);
            globalEventBus.$emit(globalEventNames.cultureChanged, currentCulture);
        },

        // registrazione autenticazione utente avvenuta
        setLoggedUser: async (state, loggedUser) => {
            if (loggedUser) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + loggedUser.token;
                localStorage.setItem('01/loggedUser', JSON.stringify(loggedUser));
            } else {
                delete axios.defaults.headers.common['Authorization'];
                localStorage.removeItem('01/loggedUser');
            }
            state.loggedUser = loggedUser;
        },

        // imposta lo stato attivo e disattivo di chiamate ajax
        setBusy: (state, busy) => state.busy = busy,

        // imposta il layout utilizzato per la visualizzazione della pagina gestita dal router
        setLayout(state, layout) {
            if (state.layout !== layout)
                state.layout = layout;
        }

    },

    actions: {

        setUserAndCulture({commit, dispatch}, user) {
            commit(globalStoreMethods.mutations.setLoggedUser, user);
            if (user) {
                //if (!state.currentCulture) {
                if (user.cultures.filter((x) => x.isDefault).length > 0) {
                    dispatch(globalStoreMethods.actions.changeCulture, user.cultures.filter((x) => x.isDefault)[0]);
                }
                //}
            } else {
                dispatch(globalStoreMethods.actions.changeCulture, null);
            }
        },

        // cambio lingua d'interfaccia
        async changeCulture({commit}, newCultureToUse) {
            await loadLanguageAsync(newCultureToUse).then(() => commit('_setCurrentCulture', newCultureToUse));
        },

        // init lo stato in avvio (caricamento dati asincroni)
        async init({commit}, clientAppToken) {
            commit('_setClientAppToken', clientAppToken);

            const startupDataEndpoints = ['/api/common/cultures', '/api/common/time-zones'];
            axios.all(startupDataEndpoints.map((promise) => axios.get(promise))).then(
                axios.spread((allCulturesResponse, timeZonesResponse) => {

                    const allCultures = allCulturesResponse.results;
                    const timeZones = timeZonesResponse.results;

                    commit('_setReady', {allCultures, timeZones});

                    if (!JSON.parse(localStorage.getItem('01/loggedUser')))
                        commit('_setCurrentCulture', allCultures.find(a => a.id === 18));

                })
            );

        },


    },

});

if (JSON.parse(localStorage.getItem('01/loggedUser')))
    globalStore.dispatch(globalStoreMethods.actions.setUserAndCulture, JSON.parse(localStorage.getItem('01/loggedUser')));


// restituzione store composto
export default globalStore;